// extracted by mini-css-extract-plugin
export default {"container":"ExtraComponent_container__pKZKy","container_box":"ExtraComponent_container_box__VU-n0"};